export enum EWorkspaceActionType {
  CLOSE = 'workspace/CLOSE',
  CHART_CLEAR = 'workspace/chart/CLEAR',
  CHART_SET = 'workspace/chart/SET',
  ACTIVE_PANEL_SET = 'confirmPanel/SET_ACTIVE_PANEL',
  EXIT_ACTIVE_PANEL = 'confirmPanel/EXIT_ACTIVE_PANEL',
}
